var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-card" }, [
    _c("div", { staticClass: "page-card_head" }, [_vm._t("header")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "page-card_body" }, [_vm._t("body")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }